import script from "./footer.vue?vue&type=script&setup=true&name=footer&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&name=footer&lang=js"

import "./footer.vue?vue&type=style&index=0&id=b094025e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b094025e"]])

export default __exports__